import { DragNDrop } from "@tfg/ui"
import { useEffect, useState } from "react"

import { FindOperationChainItemsResponseDto } from "~/gen/api"
import { useDeleteOperationChainItemMutation } from "~/pages/Admin/Ingestion/OpChains/hooks/useDeleteOperationChainItemMutation"
import { useUpdateOperationChainItemMutation } from "~/pages/Admin/Ingestion/OpChains/hooks/useUpdateOperationChainItemMutation"

type Props = {
  operationChainId: string
  activityItems: FindOperationChainItemsResponseDto[]
}

export function OpChainDragDrop({ operationChainId, activityItems }: Props) {
  const { mutate: updateOpChainItem } = useUpdateOperationChainItemMutation()
  const { mutate: deleteOpChainItem } = useDeleteOperationChainItemMutation()
  const [list, setList] = useState(() =>
    activityItems.map((item) => ({
      id: item.activityId,
      label: item.activityName,
      position: item.position,
    }))
  )

  useEffect(() => {
    setList(
      activityItems.map((item) => ({
        id: item.activityId,
        label: item.activityName,
        position: item.position,
      }))
    )
  }, [activityItems])

  return (
    <DragNDrop
      data={list}
      onDragEnd={({ item, destination }) => {
        if (!destination || destination.index === null) return
        updateOpChainItem({
          activityId: item.id,
          operationChainId,
          newPosition: destination.index + 1,
        })
      }}
      deletable
      onDelete={(id) => {
        deleteOpChainItem({
          activityId: id,
          operationChainId,
        })
      }}
    />
  )
}
